import { setCookie, checkCookie } from './cookie-helpers.js';

/**
 * Function to handle spotlight functionality.
 */
function simulator() {
	const simulatorElement = document.querySelector(
		'dialog[data-modal="simulator"]'
	);

	const popupElement = document.querySelector(
		'dialog.popup-simulator[data-modal="simulator"]'
	);

	if (!simulatorElement) {
		return;
	}

	if (!document.body.classList.contains('page-template-page-trips')) {
		return;
	}

	if (window.innerWidth <= 600) {
		popupSimulator(popupElement);
	} else {
		notificationSimulator(simulatorElement);
	}
}

/**
 * Initializes the notification spotlight module.
 *
 * @param {HTMLElement} el - The element representing the notification spotlight.
 * @returns {void}
 */
function notificationSimulator(el) {
	const notificationSimulator = el;
	const notificationSimulatorClosed = checkCookie(
		'notificationSimulatorClosed'
	);

	if (notificationSimulatorClosed) {
		return;
	}

	// Create a new MutationObserver instance
	const observer = new MutationObserver((mutationsList) => {
		for (const mutation of mutationsList) {
			if (
				mutation.type === 'attributes' &&
				mutation.attributeName === 'class'
			) {
				if (notificationSimulator.classList.contains('available')) {
					setTimeout(() => {
						notificationSimulator.show();
					}, 5000);
				}
			}
		}
	});

	// Start observing changes to the class attribute of the element
	observer.observe(notificationSimulator, { attributes: true });

	notificationSimulator.addEventListener('close', (e) => {
		setCookie('notificationSimulatorClosed', 'true', 7);
	});
}

/**
 * Function to display a popup spotlight.
 *
 * @param {HTMLElement} el - The element representing the popup spotlight.
 * @returns {void}
 */
function popupSimulator(el) {
	// init popup spotlight
	const popupSimulator = el;
	const popupSimulatorClosed = localStorage.getItem('popupSimulatorClosed');

	if (popupSimulatorClosed === 'true') {
		return;
	}

	popupSimulator.addEventListener('close', (e) => {
		localStorage.setItem('popupSimulatorClosed', 'true');
	});

	setTimeout(() => {
		popupSimulator.showModal();
	}, 1000);
}

export { simulator };
